// Runtime gate consulted by AddFormV1/EditFormV1 so a role's Form
// Configuration (Role Configure → Form) actually restricts the real add/edit
// form, not just the admin preview. rolePerms is the array returned by
// GET /admin/role-form-permissions (see adminApi.js getRoleFormPermissions):
// [{ name, enabled, locked, fields: [{ field, enabled, locked }] }].
//
// Fails OPEN (returns true) whenever rolePerms is null/empty/not-yet-loaded —
// a module or role with no derived permissions behaves exactly as before
// (gated only by Form Groups' own show/visiblePermission), so this is purely
// additive and cannot hide a field that used to render.
export function groupAllowedByRole(rolePerms, groupName) {
  if (!rolePerms) return true;
  const group = rolePerms.find((g) => g.name === groupName);
  if (!group) return true;
  return group.enabled !== false;
}

export function fieldAllowedByRole(rolePerms, groupName, fieldKey) {
  if (!rolePerms) return true;
  const group = rolePerms.find((g) => g.name === groupName);
  if (!group) return true;
  const field = group.fields?.find((f) => f.field === fieldKey);
  if (!field) return true;
  return field.enabled !== false;
}
